import { useAtom } from 'jotai';

import { SegmentedControl } from '@/components/glitch-ui/segmented-control';
import { consolidatedPerformanceScopeAtom } from '@/store';
import { PlatformLogo } from '@/lib/performance/platform';
import type { PlatformScope } from '@/lib/performance/types';

// Master platform scope switch for the consolidated Performance surface (#5971).
// 'all' shows both platforms side by side; Google / Meta narrow every tab to one.
// Renders via the shared SegmentedControl (#4332 extracted the idiom to glitch-ui).
const OPTIONS: { value: PlatformScope; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'google', label: 'Google' },
  { value: 'meta', label: 'Meta' },
];

export function PlatformScopeSwitch() {
  const [scope, setScope] = useAtom(consolidatedPerformanceScopeAtom);
  return (
    <SegmentedControl
      ariaLabel="Platform scope"
      value={scope}
      onChange={setScope}
      options={OPTIONS.map((option) => ({
        ...option,
        icon:
          option.value !== 'all' ? (
            <PlatformLogo platform={option.value} className="h-3.5 w-3.5 shrink-0" />
          ) : undefined,
      }))}
    />
  );
}
